var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7688 6.71387H13.2312C15.5886 6.71387 17.5 8.58307 17.5 10.8885V15.8254C17.5 18.1308 15.5886 20 13.2312 20H4.7688C2.41136 20 0.5 18.1308 0.5 15.8254V10.8885C0.5 8.58307 2.41136 6.71387 4.7688 6.71387ZM8.99492 15.3295C9.49283 15.3295 9.88912 14.9419 9.88912 14.455V12.2489C9.88912 11.772 9.49283 11.3844 8.99492 11.3844C8.50717 11.3844 8.11088 11.772 8.11088 12.2489V14.455C8.11088 14.9419 8.50717 15.3295 8.99492 15.3295Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.522 5.39595V6.86667C14.1663 6.7673 13.7904 6.71761 13.4042 6.71761H12.7437V5.39595C12.7437 3.37868 11.0671 1.73903 9.00436 1.73903C6.9416 1.73903 5.26497 3.36874 5.25481 5.37608V6.71761H4.60448C4.20818 6.71761 3.83221 6.7673 3.47656 6.87661V5.39595C3.48672 2.41476 5.95594 0 8.98403 0C12.0528 0 14.522 2.41476 14.522 5.39595",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.9c337122fcc68e3e034215ea8e0fde05.svg";
export { ForwardRef as ReactComponent };